export const isDefined = (value: unknown): value is NonNullable<unknown> =>
  value !== undefined && value !== null;

export const removeSpaces = (value: string) => value.replace(/ /g, '');

export const generateRandomKey = () => Math.random().toString(36).slice(2);

export const getSafeNumber = (value: number | null): number =>
  value !== null ? value : 0;

export const isPositiveNumber = (value: number): boolean => value >= 0;
